import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MERCHANDISING_COLLECTION_SLICE_QUERY_KEY } from './useGetMerchandisingCollectionSlice';
import { MERCHANDISING_COLLECTION_SLICE_PRODUCTS_QUERY_KEY } from './useGetMerchandisingCollectionSliceProducts';
import { MERCHANDISING_COLLECTION_SLICES_QUERY_KEY } from './useGetMerchandisingCollectionSlices';
import { GET_PRODUCTS_QUERY_KEY } from './useGetProducts';

import MerchandisingCollectionsService, {
  MerchandisingCollectionSlice,
} from '@/services/MerchandisingCollectionsService';

export function useRemoveMerchandisingCollectionSliceProduct() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      collectionId,
      sliceId,
      productId,
    }: {
      collectionId: number;
      sliceId: number;
      productId: string;
    }) =>
      MerchandisingCollectionsService.removeSliceProduct(
        collectionId,
        sliceId,
        productId,
      ),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: MERCHANDISING_COLLECTION_SLICES_QUERY_KEY,
      });

      queryClient.setQueryData<MerchandisingCollectionSlice>(
        [
          ...MERCHANDISING_COLLECTION_SLICE_QUERY_KEY,
          variables.collectionId,
          variables.sliceId,
        ],
        data.data.slice,
      );

      queryClient.invalidateQueries({
        queryKey: MERCHANDISING_COLLECTION_SLICE_PRODUCTS_QUERY_KEY,
      });

      queryClient.invalidateQueries({
        queryKey: GET_PRODUCTS_QUERY_KEY(),
      });
    },
  });

  return {
    removeSliceProduct: mutateAsync,
    isLoading: isPending,
  };
}
